import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const BenefitsContainer = styling("div")({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gridTemplateRows: "repeat(2, 1fr)",
  gap: "1rem",
  marginTop: "1rem",

  "@media (max-width: 640px)": {
    display: "flex",
    overflowX: "scroll",
    padding: "0.125rem ",
  },

  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const CardStyled = styling("div")({
  backgroundColor: Color.white,
  boxShadow: `0 0 0 1px ${Color.grey}`,
  borderRadius: "0.5rem",
  padding: "1rem",
  width: "100%",
  minHeight: "11.75rem",

  transition: "box-shadow 0.15s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      "> *": {
        transition: "all 0.2s ease-in-out",
        color: Color.hiredlyPurple,
      },
      boxShadow: `0 0 0 2px ${Color.hiredlyPurple}`,
      overflow: "hidden",
    },
  },

  "@media (max-width: 640px)": {
    minWidth: "15.625rem",
    minHeight: "16.25rem",
  },
});

export const FontAwesomeIconStyled = styling(FontAwesomeIcon)({
  maxWidth: "56px",
  height: "100%",
  padding: "0.3125rem",

  "@media (max-width: 1280px)": {
    padding: "0.25rem",
    maxWidth: "40px",
  },
});
